import { render, staticRenderFns } from "./AdminQuotesEditScreen.vue?vue&type=template&id=ed4d175e&scoped=true&"
import script from "./AdminQuotesEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminQuotesEditScreen.vue?vue&type=script&lang=js&"
import style0 from "./AdminQuotesEditScreen.vue?vue&type=style&index=0&id=ed4d175e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4d175e",
  null
  
)

export default component.exports